// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--36KWw";